(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsFilterBarReset', rmsFilterBarReset);

    function rmsFilterBarReset() {
        return {
            restrict: 'E',
            controller: rmsFilterBarResetCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/filter-bar/tools/reset'
        };
    }

    function rmsFilterBarResetCtrl($scope, MainFilterBarService) {
        var vm = this;
        this.$onInit = function() {
            vm.filterBarIdentifier = $scope.$parent.vm.filterBarIdentifier;
            MainFilterBarService.sync(vm, vm.filterBarIdentifier); // this gives vm.filterBarService();

            vm.reset = reset;

            init();
        }

        function init() {
            vm.showReset = vm.filterBarService().hasType('reset');
        }

        function reset() {
            vm.filterBarService().reset(true);
        }
    }
})();